<template>
  <div class="container-fluid">
    <div class="row flex-row">
      <div class="col-xl-9">
        <div class="widget has-shadow">
          <div class="widget-header bordered no-actions d-flex align-items-center">
            <h4>تنظیمات تبلیغ</h4>
          </div>
          <div class="widget-body">
            <form class="form-horizontal">
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end"
                  >حداکثر تماشای پشت‌سرهم</label
                >
                <div class="col-lg-6">
                  <input
                    type="number"
                    class="form-control"
                    min="1"
                    v-model.number="settings.maxContinuousAds"
                  />
                </div>
              </div>
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end"
                  >فاصله بین تبلیغ‌ها (ثانیه)</label
                >
                <div class="col-lg-6">
                  <input
                    type="number"
                    class="form-control"
                    min="0"
                    v-model.number="settings.adIntervalSeconds"
                  />
                </div>
              </div>
            </form>
            <div class="em-separator separator-dashed"></div>
            <div class="text-right">
              <button class="btn btn-gradient-01" @click="save">ذخیره تغییرات</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import adSettingsService from '../../../../services/adSettings';
export default {
  name: 'adSettings',
  data() {
    return {
      settings: {
        maxContinuousAds: 3,
        adIntervalSeconds: 30,
      },
    };
  },
  created() {
    this.loadSettings();
  },
  methods: {
    async loadSettings() {
      try {
        const settings = await adSettingsService.getAdSettings();
        this.settings = settings;
      } catch (err) {
        console.log(err);
      }
    },
    async save() {
      try {
        await adSettingsService.setAdSettings(this.settings);
        await this.loadSettings();
        window.notif({ isError: false, mssg: 'اپدیت شد' });
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
